
export default (api) => ({
  uploadFile: (data, onUploadProgress) =>
    api.post('profile/upload/', data, {
      header: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    }),


  getPlatformCategories: () => api.get('/platform/categories'),
  getProducts: () => api.get('products/'),
  addProduct: (data) => api.post('product/edit/', data),
  getProduct: (id) => api.get(`product/${id}/`),
  deleteProduct: (id) => api.delete(`product/${id}/delete/`),
  getCategories: (str) => api.get('categories/', {params:{ search: str }}),
  updateCategory: (data) => api.post('/user/category/update/', data),
  getUserCategories: () => api.get('/user/categories/'),
  getUserCategory: (id) => api.get(`/user/categories/${id}`),
  getAttributes: (id) => api.get('attributes/', {params:{category: id}}),
  getBrands: (str) => api.get('brands/', {params:{search: str}}),
  addAttribute: (data) => api.post('attribute/add/', data),
  addOption: (data) => api.post('option/add/', data),
  uploadImages: (data) => api.post('upload/', data),
  exportProducts: (data) => api.post('product/export/', data),
  importProducts: (platform, stockId) => api.get('product/import/', {params: { platform, stockId}}),
  searchOttoCategoryGroups: (data) => api.get('otto-category-group/search/', {params: {search: data}}),
  getOttoCategoryGroup: (id) => api.get(`otto/category-group/${id}`),
  getOttoGroupCategories: (data) => api.get('otto-categories/', {params: {categoryGroup: data}}),
  getPlatforms: () => api.get('platforms/'),
  searchAmazonCategories: (data) => api.get('amazon/category/search/', {params: {search: data}}),
  getEbayCategories: (level) => api.get('ebay/categories/', {params: {level}}),
  getEbayChildrenCategories: (parentId) => api.get('ebay/categories/children/', {params: {parentId}}),
  getOttoAuthCode: () => api.get('get-otto-auth-code'),
  getEbayAuthCode: () => api.get('get-ebay-auth-code'),
  getAmazonAuthCode: () => api.get('get-amazon-auth-code'),
  getActions: () => api.get('actions/'),
  updateActionStatus: (id, type) => api.get(`action/${id}/${type}/`),
  getOttoCategoryAttributes:(id) => api.get(`otto-category-attributes/${id}`),
  getOrders:(platform) => api.get('orders', {params:{platform}}),
  getOrder:(id) => api.get(`order/`, {params:{id}}),
  getAmazonCategory: (id) => api.get('amazon/category/', {params:{id}}),
  setUserEbayToken: (code) => api.get('ebay-token/', {params:{code}}),
  getEbayCategoryAspects: (id) => api.get('ebay-category-aspects/', {params:{id}}),
  convert: (platform) =>api.get('convert', {params:{platform}}),

  getStocks: () => api.get('stocks'),
  getStock: (id) => api.get(`stocks/${id}`),
  deleteStock: (id) => api.post('stocks/delete', {id}),
  addStock: (stock) => api.post('stocks/add', stock),


})
